import { css, CSSResult } from 'lit'

export const cscStoreLocatorList = {
  height: css`var(--csc-store-locator-list-height, 650px)`
}

export const style: CSSResult = css`
  .csc-stores-list {
    height: var(--csc-store-locator-list-height);
    overflow-y: auto;
    display: block;
  }
  
  .bottom {
    bottom: 25px;
  }
  
  .top {
    top: 25px;
  }
`
